import { MenuRoute } from '../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the CRM module.
 * Only static (non-parameterized) routes are listed.
 */
export const CRM_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/crm/dashboard',
    labelKey: 'Crm.dashboard',
    icon: '/assets/tablerIcons/outline/layout-dashboard.svg',
    moduleId: 31,
    groupLabelKey: 'MenuRoutes.group.crmOverview'
  },
  {
    path: '/crm/customers',
    labelKey: 'Crm.customers',
    icon: '/assets/tablerIcons/outline/building.svg',
    moduleId: 31,
    groupLabelKey: 'MenuRoutes.group.crmEntities'
  },
  {
    path: '/crm/contacts',
    labelKey: 'Crm.contacts',
    icon: '/assets/tablerIcons/outline/users.svg',
    moduleId: 31,
    groupLabelKey: 'MenuRoutes.group.crmEntities'
  },
  {
    path: '/crm/meetings',
    labelKey: 'Crm.meetings',
    icon: '/assets/tablerIcons/outline/calendar-event.svg',
    moduleId: 31,
    groupLabelKey: 'MenuRoutes.group.crmActivities'
  },
  {
    path: '/crm/activities',
    labelKey: 'Crm.activities',
    icon: '/assets/tablerIcons/outline/activity.svg',
    moduleId: 31,
    groupLabelKey: 'MenuRoutes.group.crmActivities'
  },
  {
    path: '/crm/correspondence',
    labelKey: 'Crm.correspondence',
    icon: '/assets/tablerIcons/outline/mail.svg',
    moduleId: 31,
    groupLabelKey: 'MenuRoutes.group.crmActivities'
  },
  {
    path: '/crm/pipeline',
    labelKey: 'Crm.pipeline',
    icon: '/assets/tablerIcons/outline/git-branch.svg',
    moduleId: 31,
    groupLabelKey: 'MenuRoutes.group.crmPipeline'
  },
  {
    path: '/crm/pipeline/dashboard',
    labelKey: 'Crm.pipelineDashboard',
    icon: '/assets/tablerIcons/outline/chart-bar.svg',
    moduleId: 31,
    groupLabelKey: 'MenuRoutes.group.crmPipeline'
  },
  {
    path: '/crm/pipeline/analysis',
    labelKey: 'Crm.pipelineAnalysis',
    icon: '/assets/tablerIcons/outline/chart-pie.svg',
    moduleId: 31,
    groupLabelKey: 'MenuRoutes.group.crmPipeline'
  },
  {
    path: '/crm/tasks',
    labelKey: 'Crm.tasks',
    icon: '/assets/tablerIcons/outline/checklist.svg',
    moduleId: 31,
    groupLabelKey: 'MenuRoutes.group.crmTasks'
  },
  {
    path: '/crm/calendar',
    labelKey: 'Crm.calendar',
    icon: '/assets/tablerIcons/outline/calendar.svg',
    moduleId: 31,
    groupLabelKey: 'MenuRoutes.group.crmTasks'
  },
  {
    path: '/crm/agreements',
    labelKey: 'Crm.agreements',
    icon: '/assets/tablerIcons/outline/file-description.svg',
    moduleId: 31,
    groupLabelKey: 'MenuRoutes.group.crmAgreements'
  },
  {
    path: '/crm/agreements/dashboard',
    labelKey: 'Crm.agreementsDashboard',
    icon: '/assets/tablerIcons/outline/chart-line.svg',
    moduleId: 31,
    groupLabelKey: 'MenuRoutes.group.crmAgreements'
  },
  {
    path: '/crm/settings',
    labelKey: 'Crm.settings',
    icon: '/assets/tablerIcons/outline/settings.svg',
    moduleId: 31,
    groupLabelKey: 'MenuRoutes.group.crmConfig',
    requiresAdmin: true
  }
];
